module.exports = __webpack_public_path__ + "img/1541397294.dce9a438.jpg";